import { FC } from 'react';

const TileWithoutDefaultStyling: FC<{
  children: JSX.Element | JSX.Element[];
  className?: string;
}> = ({ children, className = '' }) => {
  return <div className={`${className || ''}`}>{children}</div>;
};

export default TileWithoutDefaultStyling;
